module.exports = __webpack_public_path__ + "static/0020-50273841258e6fbb1141c85433eaa04f.png";